import StoriesPage from './StoriesPage'

export default StoriesPage